/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Select_All_Events_From_CurrentInputs */



/**
* | output |
* | --- |
* | "Select all Events in Event Group starting the currently selected event." |
*
* @param {Shortcut_Keys_Desc_Select_All_Events_From_CurrentInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_select_all_events_from_current = /** @type {((inputs?: Shortcut_Keys_Desc_Select_All_Events_From_CurrentInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Select_All_Events_From_CurrentInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionner tous les evenements du groupe a partir de l'evenement selectionne.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie alle Ereignisse in der Ereignisgruppe aus, beginnend mit dem aktuell ausgewählten Ereignis.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona tutti gli eventi nel gruppo eventi avviando l'evento attualmente selezionato.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите все события в группе событий, начиная с текущего выбранного события.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar todos los eventos en el grupo de eventos comenzando por el evento seleccionado actualmente.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择事件组中从当前选定事件开始的所有事件。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("現在選択されているイベントから始まるイベント グループ内のすべてのイベントを選択します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वर्तमान में चयनित इवेंट से शुरू होने वाले इवेंट ग्रुप में सभी इवेंट्स का चयन करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione todos os eventos no grupo de eventos, começando pelo evento atualmente selecionado.")
	return /** @type {LocalizedString} */ ("Select all Events in Event Group starting the currently selected event.")
});